import { CategoryItem } from '../../features/catalogo/components/catalog-sidebar.component';
import { CategoryCard, MenuItem } from '../models/interfaces-general';
import { CategoriaApi } from '../models/api/categoria-api';
import { Constante } from '../../constante';

export class CategoriaMapper {
    static toMenu(categorias: CategoriaApi[]): MenuItem[] {
        return (categorias ?? [])
            .filter((item) => item.mostrarEnMenu)
            .map((item) => this.toMenuItem(item));
    }

    static toMenuItem(item: CategoriaApi): MenuItem {
        const children = (item.hijos ?? [])
            .filter((hijo) => hijo.mostrarEnMenu)
            .map((hijo) => this.toMenuItem(hijo));

        return {
            label: item.nombre,
            url: `${Constante.URL_CATALOGO}/${item.slug ?? item.id}`,
            children: children.length > 0 ? children : undefined
        };
    }

    static toCard(item: CategoriaApi): CategoryCard {
        return {
            title: item.nombre,
            imageUrl: item.urlImagen || '',
            targetUrl: `${Constante.URL_CATALOGO}/${item.slug ?? item.id}`
        };
    }

    static toSidebar(item: CategoriaApi): CategoryItem {
        return {
            id: item.id,
            slug: item.slug,
            name: item.nombre,
            count: item.cantidadProductos,
            children: (item.hijos ?? []).map((hijo) => this.toSidebar(hijo))
        };
    }

    static flatten(categorias: CategoriaApi[]): CategoriaApi[] {
        const result: CategoriaApi[] = [];
        const walk = (items: CategoriaApi[]) => {
            for (const item of items ?? []) {
                result.push(item);
                if (item.hijos?.length) {
                    walk(item.hijos);
                }
            }
        };
        walk(categorias ?? []);
        return result;
    }

    static findById(categorias: CategoriaApi[], id: number): CategoriaApi | null {
        return this.flatten(categorias).find((item) => item.id === id) ?? null;
    }

    static findBySlug(categorias: CategoriaApi[], slug: string): CategoriaApi | null {
        return this.flatten(categorias).find((item) => item.slug === slug) ?? null;
    }
}
